import { createSvgIcon } from '@mui/material';
import Styled from "./custom-styled-icon";

export const ThreeDotIcon = Styled(
    createSvgIcon(
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                stroke="currentColor"
                fill='none'
                d="M7.33333 10.6667C6.6 10.6667 6 11.2667 6 12.0001C6 12.7334 6.6 13.3334 7.33333 13.3334C8.06667 13.3334 8.66667 12.7334 8.66667 12.0001C8.66667 11.2667 8.06667 10.6667 7.33333 10.6667Z" stroke="#656669" />
            <path
                stroke="currentColor"
                fill='none'
                d="M16.6666 10.6667C15.9333 10.6667 15.3333 11.2667 15.3333 12.0001C15.3333 12.7334 15.9333 13.3334 16.6666 13.3334C17.3999 13.3334 17.9999 12.7334 17.9999 12.0001C17.9999 11.2667 17.3999 10.6667 16.6666 10.6667Z" stroke="#656669" />
            <path
                stroke="currentColor"
                fill='none'
                d="M12.0001 10.6667C11.2667 10.6667 10.6667 11.2667 10.6667 12.0001C10.6667 12.7334 11.2667 13.3334 12.0001 13.3334C12.7334 13.3334 13.3334 12.7334 13.3334 12.0001C13.3334 11.2667 12.7334 10.6667 12.0001 10.6667Z" stroke="#656669" />
        </svg>
        ,
        "ThreeDotIcon",
    ),
)

export default ThreeDotIcon;
